import { cn } from "../../lib/utils"

type NovaMarkProps = {
  className?: string
  /** Adds the product name beside the symbol for full-brand placements. */
  wordmark?: boolean
  inverted?: boolean
}

/**
 * Nova's product mark: a rising path with a bright guide point. It stays code-native so
 * it is sharp at navigation, sign-in, and favicon-adjacent sizes without
 * introducing another image asset or a second visual system.
 */
export function NovaMark({ className, wordmark = false, inverted = false }: NovaMarkProps) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <svg
        viewBox="0 0 28 28"
        role="img"
        aria-label={wordmark ? undefined : "Nova"}
        aria-hidden={wordmark ? true : undefined}
        className="size-7 shrink-0"
      >
        <rect
          x="1"
          y="1"
          width="26"
          height="26"
          rx="8"
          strokeWidth="1.25"
          className={
            inverted
              ? "fill-primary-foreground stroke-primary-foreground/30"
              : "fill-card stroke-border"
          }
        />

        <path
          d="M7.4 18.9 13.2 8.7l7.4 10.2M9.4 15.4h8.8"
          fill="none"
          strokeWidth="2.15"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={inverted ? "stroke-primary" : "stroke-foreground"}
        />

        <circle cx="20.7" cy="7.4" r="2.35" className="fill-info" />
      </svg>

      {wordmark ? (
        <span className="text-sm font-semibold tracking-[-0.02em] text-current">Nova</span>
      ) : null}
    </span>
  )
}
